import { useQuery } from "react-query"
import PortfolioService from "~services/PortfolioService"

const useAggregatedPortfolios = (
  userId: string,
  onSuccessCallback: (data: any) => void
) => {
  return useQuery<any, Error>(
    ["user-aggregated-portfolio", userId],
    () => PortfolioService.getUserAggregatedPortfolios(userId),
    {
      enabled: false,
      onSuccess: onSuccessCallback,
    }
  )
}

export default useAggregatedPortfolios
